// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle-button{margin:0 0 4px;-webkit-margin-end:10px;margin-inline-end:10px}.toggle-button__content{background:none;border:none;outline:none;cursor:pointer}.toggle-button__content-icon{opacity:1}.toggle-button__content-icon--faded{opacity:.2}.toggle-button__content--disabled{cursor:default;opacity:.5}.toggle-button--negative{background-color:#000}.toggle-button--negative button{color:#fff!important}", ""]);
// Exports
module.exports = exports;
